import { css } from '@emotion/css';
import { Button, Content, DotBar } from '@volumental/common';
import { type JSX } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { uiConfig } from '../../../services/config';

const imageContainerStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  min-height: 8rem;
  min-width: 8rem;
  justify-items: center;
  justify-self: center;
  align-self: center;
  justify-content: center;
`;

const imageStyle = css`
  aspect-ratio: 1;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 1rem;
`;

const instructionStyle = css`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  font-family: ${uiConfig.styles.fontFamily};
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: 21px;
  color: ${uiConfig.styles.colors.black};
  padding-bottom: 2rem;
  text-align: center;
  height: 3rem;
  padding-top: 1.5rem;
  max-lines: 3;
`;

const dotbarStyle = css`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  height: 2rem;
  padding-top: 1rem;
  text-align: center;
`;

interface OnboardingImagePageProps {
  instruction: string | JSX.Element;
  imageSrc: string;
  imageNumber?: number;
  imageCount?: number;
  buttonText: string;
  altText: string;
  onClick?: () => void;
}

export function OnboardingImagePage({
  instruction,
  imageSrc,
  imageNumber,
  imageCount,
  buttonText,
  altText,
  onClick,
}: OnboardingImagePageProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <Content disableScrollbar>
        <div className={imageContainerStyle}>
          <img
            data-cy="onboarding-image"
            src={imageSrc}
            alt={altText}
            className={imageStyle}
          />
        </div>
        <div className={instructionStyle}>
          <Trans>{instruction}</Trans>
        </div>
      </Content>
      <div className={dotbarStyle}>
        {imageCount && imageNumber && (
          <DotBar
            altText={t('imageAlt.stepDot')}
            activeStep={imageNumber - 1}
            stepsCount={imageCount}
          />
        )}
      </div>
      <div style={{ padding: '24px' }}>
        <Button onClick={onClick}>{buttonText}</Button>
      </div>
    </>
  );
}
